import bgSignUpBlue from "../images/signup/bg-signup-blue.svg"
import bgSignUpGreen from "../images/signup/bg-signup-green.svg"
import bgSignUpLightBlue from "../images/signup/bg-signup-lightblue.svg"
import bgSignUpPurple from "../images/signup/bg-signup-purple.svg"
import bgSignUpRed from "../images/signup/bg-signup-red.svg"
import bgSignUpTeal from "../images/signup/bg-signup-teal.svg"
import bgSignUpYellow from "../images/signup/bg-signup-yellow.svg"
import bgCornerBlue from "../images/signup/corners/blue-corner.svg"
import bgCornerGreen from "../images/signup/corners/green-corner.svg"
import bgCornerRed from "../images/signup/corners/red-corner.svg"
import bgCornerTeal from "../images/signup/corners/teal-corner.svg"
import bgCornerYellow from "../images/signup/corners/yellow-corner.svg"

const BackgroundColor = {
  Red: "Red",
  Green: "Green",
  Blue: "Blue",
  Yellow: "Yellow",
  Purple: "Purple",
  Teal: "Teal",
  LightBlue: "Light Blue",
}

export const getPackageColor = (color) =>
  color === BackgroundColor.Blue ? BackgroundColor.LightBlue : color

export const getBackgroundImage = (background) => {
  switch (background) {
    case BackgroundColor.Red:
      return bgSignUpRed
    case BackgroundColor.Green:
      return bgSignUpGreen
    case BackgroundColor.Blue:
      return bgSignUpBlue
    case BackgroundColor.LightBlue:
      return bgSignUpLightBlue
    case BackgroundColor.Yellow:
      return bgSignUpYellow
    case BackgroundColor.Purple:
      return bgSignUpPurple
    case BackgroundColor.Teal:
      return bgSignUpTeal
    default:
      return null
  }
}

export const getCorner = (background) => {
  switch (background) {
    case BackgroundColor.Red:
      return bgCornerRed
    case BackgroundColor.Green:
      return bgCornerGreen
    case BackgroundColor.Blue:
      return bgCornerBlue
    case BackgroundColor.Yellow:
      return bgCornerYellow
    case BackgroundColor.Teal:
      return bgCornerTeal
    default:
      return null
  }
}
